/** @fileoverview Inline notice while the backend is still preparing the student's tasks (polling). */

import { Alert, Group, Loader, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export function StudentTrackerProcessingNotice() {
  const { t } = useTranslation()

  return (
    <Alert color='blue' radius='md' py='xs'>
      <Group spacing='xs' noWrap>
        <Loader size='xs' />
        <Text size='sm'>{t('student_task_tracker.processing')}</Text>
      </Group>
    </Alert>
  )
}
